export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
                d="M5.35223 3.33249L10.5745 2.37449C10.9638 2.30307 11.3539 2.45683 11.5745 2.76865L14.3444 6.6854C14.5343 6.95394 14.5706 7.30113 14.4411 7.61016L10.743 16.4339C10.5296 16.9432 9.93706 17.1996 9.41966 17.0064L1.43663 14.0259C0.919228 13.8327 0.672848 13.2632 0.886321 12.7538L4.57524 3.95185C4.70973 3.63094 5.00401 3.39637 5.35223 3.33249Z"
                fill="url(#paint0_linear_725_2945)"
                stroke="url(#paint1_linear_725_2945)"
            />
            <path
                d="M6.26902 4.64683L11.336 1.52992C11.6685 1.32537 12.0896 1.33303 12.4145 1.54952L17.0562 4.64282C17.3345 4.82827 17.5017 5.14056 17.5017 5.47497V16.3461C17.5017 16.8984 17.0539 17.3461 16.5017 17.3461H6.79297C6.24068 17.3461 5.79297 16.8984 5.79297 16.3461V5.49858C5.79297 5.15126 5.97319 4.82881 6.26902 4.64683Z"
                fill="#FDF6E8"
                stroke="url(#paint2_linear_725_2945)"
            />
            <path
                d="M11.4995 6.84367C11.4995 7.39595 11.0518 7.84367 10.4995 7.84367C9.94723 7.84367 9.49951 7.39595 9.49951 6.84367C9.49951 6.29138 9.94723 5.84367 10.4995 5.84367C11.0518 5.84367 11.4995 6.29138 11.4995 6.84367Z"
                fill="url(#paint3_linear_725_2945)"
            />
            <path
                d="M14.4995 12.8437C14.4995 13.396 14.0518 13.8437 13.4995 13.8437C12.9472 13.8437 12.4995 13.396 12.4995 12.8437C12.4995 12.2914 12.9472 11.8437 13.4995 11.8437C14.0518 11.8437 14.4995 12.2914 14.4995 12.8437Z"
                fill="url(#paint4_linear_725_2945)"
            />
            <path d="M14.8955 7.14453L9.39551 13.1445" stroke="url(#paint5_linear_725_2945)" strokeLinecap="round" />
            <defs>
                <linearGradient id="paint0_linear_725_2945" x1="13.5454" y1="5.56275" x2="2.56033" y2="14.1992" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EBD3AE" />
                    <stop offset="1" stopColor="#EBD1AD" />
                </linearGradient>
                <linearGradient id="paint1_linear_725_2945" x1="13.9245" y1="5.70429" x2="1.87547" y2="13.6115" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F8D593" />
                    <stop offset="1" stopColor="#C6904E" />
                </linearGradient>
                <linearGradient id="paint2_linear_725_2945" x1="16.1506" y1="3.74461" x2="6.9582" y2="16.5828" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F8D593" />
                    <stop offset="1" stopColor="#C6904E" />
                </linearGradient>
                <linearGradient id="paint3_linear_725_2945" x1="10.4995" y1="5.84375" x2="10.4995" y2="7.84375" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F0C987" />
                    <stop offset="1" stopColor="#C7914F" />
                </linearGradient>
                <linearGradient id="paint4_linear_725_2945" x1="13.4995" y1="11.8438" x2="13.4995" y2="13.8438" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F0C987" />
                    <stop offset="1" stopColor="#C7914F" />
                </linearGradient>
                <linearGradient id="paint5_linear_725_2945" x1="14.2609" y1="8.0919" x2="11.1677" y2="13.5546" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F8D593" />
                    <stop offset="1" stopColor="#C6904E" />
                </linearGradient>
            </defs>
        </svg>
    );
}
